module.exports = __webpack_public_path__ + "static/media/saradomin.3b980ec8.png";